<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmh">NOVELS BY K. C. CONSTANTINE</h1><p class="dt"><em>GRIEVANCE</em></p>
<p class="dt"><em>BLOOD MUD</em></p>
<p class="dt"><em>BRUSHBACK</em></p>
<p class="dt"><em>FAMILY VALUES</em></p>
<p class="dt"><em>GOOD SONS</em></p>
<p class="dt"><em>CRANKS AND SHADOWS</em></p>
<p class="dt"><em>BOTTOM LINER BLUES</em></p>
<p class="dt"><em>SUNSHINE ENEMIES</em></p>
<p class="dt"><em>JOEY’S CASE UPON SOME MIDNIGHTS CLEAR</em></p>
<p class="dt"><em>ALWAYS A BODY TO TRADE</em></p>
<p class="dt"><em>THE MAN WHO LIKED SLOW TOMATOES</em></p>
<p class="dt"><em>A FIX LIKE THIS</em></p>
<p class="dt"><em>THE BLANK PAGE</em></p>
<p class="dt"><em>THE MAN WHO LIKED TO LOOK AT HIMSELF</em></p>
<p class="dt"><em>THE ROCKSBURG RAILROAD MURDERS</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SavingRoomForD_blur-1.vue?78af8e05